import { createIosMenu } from '../menu'

const {
  Root,
  Trigger,
  Content,
  Item,
  ItemTitle,
  ItemSubtitle,
  SubTrigger,
  Group,
  CheckboxItem,
  ItemIcon,
  Separator,
  ItemIndicator,
  ItemImage,
  Label,
  Preview,
  Arrow,
  Sub,
  SubContent,
  Auxiliary,
} = createIosMenu('ContextMenu')

export {
  Root,
  Trigger,
  Content,
  Item,
  ItemTitle,
  ItemSubtitle,
  SubTrigger,
  Group,
  CheckboxItem,
  ItemIcon,
  Separator,
  ItemIndicator,
  ItemImage,
  Label,
  Preview,
  Arrow,
  Sub,
  SubContent,
  Auxiliary,
}
